import type { SliceRouteContract } from '@/shared/lib/vsa';
import { SecuritySlicePage } from './SecuritySlicePage';

export const securityRouteContract: SliceRouteContract = {
  routeId: 'security',
  component: SecuritySlicePage,
};
